import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { AuthGuard } from '../shared/guards/auth.guard';
import { AdminGuard } from '../shared/guards/admin.guard';
import { TermsGuard } from '../shared/guards/terms.guard';
import { CreateUserComponent } from './create-user/create-user.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { AdminMainComponent } from './admin-main/admin-main.component';
import { CompanyContactsComponent } from './company-contacts/company-contacts.component';
import { MasterAdminGuard } from '../shared/guards/master-admin.guard';
import { UserFormGuard } from '../shared/guards/user-form.guard';
import { LoansGuard } from '../shared/guards/loans.guard';

const adminChildRoutes: Routes = [
  {
    path: 'admin',
    component: AdminMainComponent,
    canActivate: [AuthGuard, AdminGuard, TermsGuard, LoansGuard]
  },
  {
    path: 'admin/create',
    component: CreateUserComponent,
    canActivate: [AuthGuard, AdminGuard, UserFormGuard, TermsGuard, LoansGuard]
  },
  {
    path: 'admin/edit/:uuid',
    component: EditUserComponent,
    canActivate: [AuthGuard, AdminGuard, UserFormGuard, TermsGuard, LoansGuard]
  },
  {
    path: 'company-contacts',
    component: CompanyContactsComponent,
    canActivate: [AuthGuard, AdminGuard, TermsGuard, MasterAdminGuard, LoansGuard]
  }
];

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: adminChildRoutes,
    canActivate: [AuthGuard, AdminGuard, TermsGuard, LoansGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
